import AsyncTable from "components/AsyncTable"

const SchedulesTable = () => {
  return (
	<>
		{/* <AsyncTable isLoading={false} header={[]} data={[]} linkRow noActions canOrderBy /> */}
	</>
  )
}

export default SchedulesTable
